import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import { IFormPermissionToAssess } from "../Models/Forms/IFormPermissionToAssess";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';


import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';

@Injectable()
export class FormPermissionToAssessService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string, ) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormPermissionToAssess(id: number) {
    return this._http.get(this._baseUrl + "api/FormPermissionToAssess/" + id)
      .map((response: IFormPermissionToAssess) => response as IFormPermissionToAssess)
      .catch(this.errorHandler)
  }

  insertUpdateFormPermissionToAssess(formPermissionToAssessDetails:IFormPermissionToAssess) {
    return this._http.post(this._baseUrl + 'api/FormPermissionToAssess', formPermissionToAssessDetails)
      .map((response: IFormPermissionToAssess) => response as IFormPermissionToAssess)
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormPermissionToAssess/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  deletePermissionToAssess(id) {
    return this._http.delete(this._baseUrl + "api/FormPermissionToAssess" + id)
      .map((response: IFormPermissionToAssess) => response as IFormPermissionToAssess)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}

